// extracted by mini-css-extract-plugin
module.exports = {"element":"Heading6_element__wXPAY"};